// COIN FLIP BOOTSTRAPPER - Polished for Sense
// Overwrites existing coin-flip.js

(function () {
  const DEBUG_PREFIX = "COINDEBUG:";
  const CHECK_INTERVAL_MS = 600;
  const MAX_ATTACH_ATTEMPTS = 25;
  let flipTriggered = false;

  // List of rewards and their codes
const rewards = [
  { name: "5% Discount", code: "GOLD5" },
  { name: "10% Discount", code: "GOLD10" },
  { name: "Free Delivery", code: "FREESHIP" },
  { name: "Buy 2 Get 1 Free", code: "B2G1FREE" }
];


  function dlog(...args) {
    if (window && window.console) console.log(DEBUG_PREFIX, ...args);
  }

  // Find modal and related elements
  function findModalElements() {
    const modal = document.getElementById('coin-flip-modal');
    const overlay = document.getElementById('coin-backdrop'); // matches your HTML
    const coin = document.getElementById('coin');
    const flipBtn = document.getElementById('coin-flip-btn');
    const closeBtn = document.getElementById('coin-close');
    const resultEl = document.getElementById('coin-result');
    return { modal, overlay, coin, flipBtn, closeBtn, resultEl };
  }

  // Get checkout buttons
  function findCheckoutButtons() {
    const selectors = [
      'button[name="checkout"]',
      'input[name="checkout"]',
      'button[type="submit"][form="cart"]',
      '.cart__checkout-button',
      '[data-checkout-button]',
      '.cart__submit',
      '.cart-footer__checkout-button',
      '.totals__checkout',
      '[href*="/checkout"]',
      'cart-checkout-button button',
      '[data-testid*="Checkout"]',
      '[data-test*="checkout"]'
    ];
    const set = new Set();
    selectors.forEach(sel => {
      try { document.querySelectorAll(sel).forEach(el => set.add(el)); } catch {}
    });
    return Array.from(set);
  }

  // Show modal
  function showModal() {
    const waitForModal = () => {
      const { modal, overlay, coin, flipBtn, closeBtn, resultEl } = findModalElements();
      if (!modal || !overlay || !coin || !flipBtn || !closeBtn || !resultEl) {
        setTimeout(waitForModal, 100);
        return;
      }

      overlay.style.display = 'block';
      modal.style.display = 'flex'; // because modal uses display:flex to center
      modal.classList.remove('hidden');

      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      // Coin flip button
      flipBtn.onclick = () => flipCoin(coin, resultEl);

      // Close modal
      closeBtn.onclick = hideModal;
      overlay.onclick = hideModal;

      dlog("Modal shown successfully.");
    };
    waitForModal();
  }

  // Hide modal
  function hideModal() {
    const { modal, overlay, coin, resultEl } = findModalElements();
    if (!modal || !overlay || !coin || !resultEl) return;
    modal.classList.add('hidden');
    modal.setAttribute('aria-hidden', 'true');
    overlay.style.display = 'none';
    document.body.style.overflow = '';
    coin.classList.remove('flip');
    resultEl.textContent = '';
  }

  // Flip coin and show reward
  function flipCoin(coin, resultEl) {
  coin.classList.remove('flip');
  resultEl.textContent = '';

  setTimeout(() => {
    coin.classList.add('flip');

    setTimeout(() => {
      const rewards = ['FLIP10','B2G1FREE'];

      // Check if a discount was already applied this session
      let code = sessionStorage.getItem('coinDiscountApplied');
      if (!code) {
        code = rewards[Math.floor(Math.random() * rewards.length)];
        sessionStorage.setItem('coinDiscountApplied', code);
      }

      resultEl.textContent = `You won: ${code}`;

      setTimeout(() => {
        hideModal();
        // Redirect to checkout with the selected code (if not already applied)
        const checkoutBtn = findCheckoutButtons()[0];
        if (checkoutBtn) {
          window.location.href = `/checkout?discount=${code}`;
        }
      }, 2000);

    }, 1000);

  }, 100);
}

  
  function applyDiscountAtCheckout(code) {
  const checkoutBtn = findCheckoutButtons()[0];
  if (checkoutBtn) {
    const checkoutUrl = '/checkout?discount=' + code;
    window.location.href = checkoutUrl;
  }
}

  
  // Checkout click handler
  function handleCheckoutAttempt(e, source) {
    dlog("handleCheckoutAttempt triggered by", source);

    // Only one flip per page load
    if (flipTriggered) {
      dlog("Flip already triggered - allowing default behavior.");
      return;
    }

    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    flipTriggered = true;
    showModal();
  }

  // Attach to buttons
  function attachToButtons(btns) {
    let attached = 0;
    btns.forEach(btn => {
      if (!btn || btn.dataset.coinBound === "true") return;
      try {
        btn.addEventListener('click', e => handleCheckoutAttempt(e, "button-click"), { passive: false });
        btn.dataset.coinBound = "true";
        attached++;
        dlog("Attached listener to button:", btn);
      } catch (err) { dlog("Attach failed:", btn, "error:", err); }
    });
    return attached;
  }

  // Attach to cart forms
  function attachToForms() {
    const forms = document.querySelectorAll('form[action$="/cart"], form[form="cart"], form.cart__contents');
    let attached = 0;
    forms.forEach(form => {
      if (!form || form.dataset.coinFormBound === "true") return;
      try {
        form.addEventListener('submit', e => handleCheckoutAttempt(e, "form-submit"), { passive: false });
        form.dataset.coinFormBound = "true";
        attached++;
        dlog("Attached submit listener to form:", form);
      } catch (err) { dlog("Attach failed:", form, "error:", err); }
    });
    return attached;
  }

  // Boot attach
  function bootAttach() {
    dlog("Boot attach starting.");
    const btns = findCheckoutButtons();
    const attachedButtons = attachToButtons(btns);
    const attachedForms = attachToForms();
    dlog("attachedButtons:", attachedButtons, "attachedForms:", attachedForms);
    return { attachedButtons, attachedForms };
  }

  // Start attach loop
  function start() {
    let attempts = 0;
    const intervalId = setInterval(() => {
      attempts++;
      const res = bootAttach();
      if (res.attachedButtons > 0 || res.attachedForms > 0) {
        dlog("Listeners attached. Stopping retry.");
        clearInterval(intervalId);
        return;
      }
      if (attempts >= MAX_ATTACH_ATTEMPTS) {
        dlog("Max attempts reached. Using MutationObserver.");
        clearInterval(intervalId);
        setupMutationObserver();
      }
    }, CHECK_INTERVAL_MS);
  }

  // Observe late DOM changes
  function setupMutationObserver() {
    dlog("Setting up MutationObserver.");
    const obs = new MutationObserver(() => {
      const res = bootAttach();
      if (res.attachedButtons > 0 || res.attachedForms > 0) {
        dlog("Listeners attached via MutationObserver. Disconnecting.");
        try { obs.disconnect(); } catch {}
      }
    });
    obs.observe(document.documentElement || document.body, { childList: true, subtree: true });
  }

  // Manual debug
  window.COIN_FLIP_DEBUG = {
    triggerManual: function () { dlog("Manual trigger invoked."); showModal(); },
    status: function () {
      const { modal, overlay } = findModalElements();
      const btns = findCheckoutButtons();
      dlog("Status -> modal:", modal, "overlay:", overlay, "buttons:", btns.length, "flipTriggered:", flipTriggered);
      return { modal, overlay, buttonCount: btns.length, flipTriggered };
    }
  };

  // Kickoff
  if (document.readyState === "loading") {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  dlog("Coin flip JS loaded. Use COIN_FLIP_DEBUG.status() or .triggerManual()");
})();
